<template>
  <div>
    <form action="" style="visibility:hidden; height:0">
      <input type="file" id="picture-input" accept=".jpg, .jpeg" @input="inputImageFileChanged($event)">
    </form>
    <div class="picture-container" v-if="!inputImage">
      <div class="picture-croppedImg" @click="pictureClick">
        <img v-if="!preview" src='@/assets/default/light/placeholder-profile-picture-default-light.svg' :alt="$t('profile_picture_thumbnail_image')" />
        <img v-if="preview" :src='userProfileImage' :alt="$t('profile_picture_cropped_image')" />
      </div>
      <div class="picture-label-container">
        <div @keydown="ariaClick" role="button" tabindex="0" class="picture-label" :class="brandClass()" @click="pictureClick">
          <span class="picture-arrow"></span>
          <span class="picture-text">{{$t("profile_picture_popup_select_image")}}</span>
        </div>
        <div @keydown="ariaClick" role="button" tabindex="0" class="picture-label right" :class="brandClass()" v-if="preview" @click="removePictureClick">
          <span class="picture-delete"></span>
          <span class="picture-text">{{$t("profile_picture_popup_delete_image")}}</span>
        </div>
      </div>
    </div>
    <div v-if="inputImage">
      <Cropper 
      :triggerLoadImage="triggerLoadImage"
      :imageToCrop="inputImage"
      @imgCropped="onImgCropped"
      @dimensionAreTooBig="onDimensionAreTooBig"
      ></Cropper>
    </div>
    <div :class="[{'picture-sublabel': true},brandClass]" v-if="croppedImg">
      {{$t("profile_picture_popup_message")}}
    </div>
    <div :class="[{'picture-sublabel last': true, 'red': dimensionAreTooBig},brandClass]">
      {{$t("profile_picture_popup_requirements")}}
    </div>
  </div>
</template>

<script>
import useVuelidate from '@vuelidate/core'
import Cropper from "@/components/Cropper";
import oneUtils from "../../../../gcdm-one-library/gcdm-one-utils/src/bootstrap";

export default {
  inject:['$c', '$t', 'brandClass'],
  setup() {
    return { v$: useVuelidate() }
  },
  name: "ProfilePictureUpload",
  mixins: [oneUtils.accessibilityMixin],
  props: ["userProfileImage", "triggerLoadImage"],
  components:{
    Cropper
  },
  data: () => ({
    form: {
      inputImageFile: null,
    },
    inputImage: null,
    croppedImg:null,
    dimensionAreTooBig: false,
    preview:null
  }),
  validations: {
    form: {
      inputImageFile: {
      },
    },
  },
  mounted() {
    this.preview=this.userProfileImage;
    // this.v$.form.inputImageFile.$touch(); 
  },
  computed: {
    isButtonDisabled() {
      return !this.croppedImg || this.dimensionAreTooBig;
    },
  },
  methods: {
    onDimensionAreTooBig(){
      this.dimensionAreTooBig = true;
    },
    onImgCropped(img){
      this.dimensionAreTooBig = false;
      this.croppedImg = img
      this.$emit('imageLoaded', img);
    },
    removePictureClick(){
      this.croppedImg=null;
      this.preview=null;
      this.form.inputImageFile=null;
      // this.$refs['picture-input'].value='';
      document.getElementById('picture-input').value='';
      this.$emit('changeLabel');
    },
    pictureClick(){
      // this.$refs['picture-input'].click();
      document.getElementById('picture-input').click();
    },
    close() {
      this.$emit('onClose');
    },
    inputImageFileChanged(event) {
      const files = event.target.files || event.dataTransfer.files;
      if (!files.length) return;
      this.form.inputImageFile = files[0];
      this.v$.form.inputImageFile.$model = files[0];
      this.v$.form.inputImageFile.$touch();


            // check if format image is jpeg || jpg and size <= 5MB

      const nameLenght = this.form.inputImageFile.name.split('.').length;
      if (!((this.form.inputImageFile.name.split('.')[nameLenght - 1] === 'jpeg' || 
          this.form.inputImageFile.name.split('.')[nameLenght - 1] === 'jpg') && 
          this.form.inputImageFile.size <= 5242880 )) {
            this.dimensionAreTooBig = true;
            return;
      }

      this.$emit('enableUploadButton');

      const reader = new FileReader();

      reader.onload = (e)=> {
        this.inputImage = e.target.result;
      };

      reader.readAsDataURL(files[0]);
   
    },
  },
}
</script>
<style lang="scss" scoped>

.picture-container{
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding: 48px 0 40px;
  .picture-croppedImg{
    width: 116px;
    height: 116px;
    img {
      height: 100%;
      width: 100%;
      object-fit: cover;
      border-radius: 50%;
    }
  }
  .picture-label-container{
    display: flex;
    justify-content: center;
    align-items: center;
    .picture-label{
      margin-top: 24px;
      margin-right: 12px;
      &.right{
        margin-left: 12px;
      }
      
      .picture-arrow{
        position: absolute;
      }
      .picture-delete{
        position: absolute;
      }
      .picture-text{
        // margin-left: 15px;
        &:hover{
          font-weight: bold;
        }
      }
      &.__m{
        .picture-arrow{
          background-image: url('~@/assets/mini/light/add-mini-light.svg');
          width: 20px;
          height: 20px;
        }
        .picture-delete{
          background-image: url('~@/assets/mini/light/delete-mini-light.svg');
          width: 20px;
          height: 20px;
        }
        &.__d{
          .picture-arrow{
            background-image: url('~@/assets/mini/dark/add-mini-dark.svg');
          }
          .picture-delete{
            background-image: url('~@/assets/mini/dark/delete-mini-dark.svg');
          }
        }

        .picture-text{
          margin-left: 30px;
          font-size: 14px;
          line-height: 13px;
          font-weight: normal;
          font-family: MINISansSerif;
          text-decoration: underline;
          text-decoration-color: $dusty;
           &:hover{
            font-weight: bold;
          }
        }
      }
      &.__t{
        .picture-text{
          font-family: ToyotaSemibold;
          border-bottom: 1px solid $dusty;
          &:hover{
            border-bottom: 1px solid $toyotared;
          }
        }
      }
    }
  }
}
.picture-sublabel{
  font-size: 12px;
  color: white;
  text-align: center;
  &.__m{
    font-family: MINISansSerif;
  }
  &.last{
    margin-bottom: 40px;
  }
  &.red{
    color: $errorred;
    font-weight: bold;
  }
}



</style>
